import Layout from "@/components/layout/Layout"
import MainHeading from "@/components/common/MainHeading"
import { Download, Lock, RefreshCw, Upload } from "lucide-react"
import CommonTable, { type TableColumn } from "@/components/common/CommonTable"
import { Button } from "@/components/ui/button"

const TeamAttendance: React.FC = () => {
    const columns: TableColumn[] = [
        {
            key: "empid",
            header: "Emp ID",
        },
        {
            key: "name",
            header: "Name",
        },
        {
            key: "department",
            header: "Department",
        },
        {
            key: "shift",
            header: "Shift",
        },
        {
            key: "present",
            header: "Present",
        },
        {
            key: "absent",
            header: "Absent",
        },
        {
            key: "leave",
            header: "Leave",
        },
        {
            key: "working",
            header: "Working",
        },
        {
            key: "percentage",
            header: "%",
        },
        {
            key: "lateMarks",
            header: "Late Marks",
        },
        {
            key: "actions",
            header: "Actions",
        }
    ]

    const data = [
        {
            empid: "EMP001",
            name: "John Doe",
            department: "HR",
            shift: "9-5",
            present: 20,
            absent: 2,
            leave: 3,
            working: 25,
            percentage: "80%",
            lateMarks: 1,
            actions: "View"
        }
    ]
    return (
        <Layout>
            <div className="space-y-6">
                <div className="flex justify-between">
                    <MainHeading title="Team Attendance Records" />
                    <div>
                        <div className="flex gap-2">
                            <Button variant="outline" className="bg-white"> <Download /> Export</Button>
                            <Button variant="outline" className="bg-white"><Upload /> Import</Button>
                            <Button><RefreshCw /> Sync Biometric</Button>
                            <Button className="bg-green-600 hover:bg-green-700 "><Lock /> Lock Attendance — December 2025</Button>
                        </div>
                    </div>

                </div>
                <CommonTable columns={columns} data={data} />
            </div>
        </Layout>
    )
}

export default TeamAttendance